<template>
<div class="chapter">
<div class="inner_page">
<h1 class="chapter111" id="ack">acknowledgments</h1>
<p class="nonindent">I ran out of room so to be brief, for once, thanks to: agent extraordinaire Kate Epstein, editor Katie Anderson, daughter Katie Temple (notice a theme here?), and all of the addicted knitters who turned a hobby into a community. Sincerely, you all rock.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780740793271_epub_ack_r1.vue?b8cfb20e